import useQueries from '@/hooks/useQueries';

const useActions = () => {
  const [queries] = useQueries();
  const values = { isCMSView: false, isCreate: true };
  if (queries.token) {
    values.isCMSView = true;
  }
  return values;
};

export default useActions;
